import React from 'react';
import Skeleton from '@mui/material/Skeleton';
import { Cpu } from 'lucide-react';

export default function CpuUsageChartSkeleton() {
    return (
        <div className="oct_sys-chart-card-v2">
            <div className="oct_sys-chart-header-v2">
                <Cpu className="oct_icon" />
                <h3>CPU Usage</h3>
            </div>

            <div className="oct_sys-chart-subtitle-v2">
                <Skeleton variant="text" width="60%" />
            </div>

            <div className="oct_sys-chart-pie-wrapper-v2 oct_skeleton-chart-h140">
                <div className="oct_sys-chart-pie-center-v2">
                    <Skeleton variant="circular" width={120} height={120} />
                </div>
                <div className="oct_sys-chart-pie-center-v2">
                    <Skeleton variant="circular" width={80} height={80} className="oct_skeleton-bg-white" />
                </div>
                <div className="oct_sys-chart-pie-center-v2">
                    <Skeleton variant="text" width={40} height={40} />
                </div>
            </div>

            <div className="oct_sys-chart-legend-v2">
                <div className="legend-item">
                    <Skeleton variant="rectangular" width={12} height={12} className="color-box" />
                    <Skeleton variant="text" width={30} />
                </div>
                <div className="legend-item">
                    <Skeleton variant="rectangular" width={12} height={12} className="color-box" />
                    <Skeleton variant="text" width={30} />
                </div>
            </div>
        </div>
    );
}
